import { azureADInterface } from './azureADInterface'

export class azureAD extends azureADInterface {}